// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { HighlightBox, SectionTitle, Padding } from '@tectonics/look-and-feel/uber-v2/atoms';

type TipModel = {
  imgSrc: string,
  tipText: string,
  altText: string,
};

type TipsBoxProps = {
  title: string,
  tipsModel: ImmutableArray<TipModel>,
};

export function TipsBox({ title, tipsModel }: TipsBoxProps): Node {
  return (
    <HighlightBox>
      <Padding value="1em">
        <SectionTitle>{title}</SectionTitle>
        {tipsModel.map(({ imgSrc, tipText, altText }, index) => (
          <Tip key={index}>
            <TipIcon src={imgSrc} alt={altText} />
            <TipText>{tipText}</TipText>
          </Tip>
        ))}
      </Padding>
    </HighlightBox>
  );
}

const Tip = styled.div`
  display: flex;
  align-items: center;
  margin: 15px 0;
`;

const TipIcon = styled.img`
  flex: 0 0 auto;
  height: 100%;
`;

const TipText = styled.div`
  color: #4e5765;
  font-size: 14px;
  margin-left: 15px;
`;
